<template>
	<div class="body">
		<video ref="player" class="video-js video" playsinline></video>
		<!-- <video
			class="video"
			id="video"
			ref="player"
			:poster="`${url}?spm=a2c4g.11186623.0.0.667a5b29MyF0b4&x-oss-process=video/snapshot,t_1000,f_jpg,w_715,h_380,m_fast` || ''"
			:autoplay="false"
			:controls="true"
			:loop="false"
			playsinline
		>
			<source :src="url" type="video/mp4" />
			<source :src="url" type="video/ogg" />
			<source :src="url" type="video/webm" />
			<object :data="url" width="100vw" height="100vh"><embed :src="url" width="100vw" height="100vh" /></object>
		</video> -->
	</div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
export default {
	components: {},
	data() {
		return {
			url: '',
			player: null,
			timer: null
		};
	},
	mounted() {
		this.initShare();
		this.$dataStatistics({
			page_title: '应用领域-观看视频'
		});
		this.url = decodeURIComponent(this.$route.query.video);

		this.initPlayer();
	},
	methods: {
		initPlayer() {
			this.player = videojs(this.$refs.player, {
				sources: [
					{
						src: this.url,
						type: 'video/mp4'
					}
				],
				controlBar: {
					minHeight: 80 // 设置控制栏的最小高度为60像素
				},
				muted: true,
				autoplay: true,
				controls: true,
				iOS: false, // 禁用iOS自动全屏
				preload: 'auto'
			});
			
			// 监听播放事件启动定时器
			this.player.on('play', () => {
				this.startTimer();
			});
			
			// 监听暂停事件清除定时器
			this.player.on('pause', () => {
				this.clearTimer();
			});
		},
		startTimer() {
			if (!this.timer) {
				this.timer = setInterval(() => {
					this.scoreAdd();
				}, 300000); //五分钟
			}
		},
		clearTimer() {
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null; // 确保清除定时器引用
			}
		},
		scoreAdd() {
			if (!this.$route.query.id) return;
			//加积分
			let data = {
				moduleid: Number(this.$route.query.id)
			};
			this.$http.post('/api/platform/user/score/videolog', data).then((res) => {});
		}
	},
	beforeDestroy() {
		// 清除定时器
		if (this.timer) {
			clearInterval(this.timer);
		}
		// 销毁视频播放器实例
		if (this.player) {
			this.player.dispose();
		}
	}
	// beforeRouteLeave(to, from, next) {
	// 	this.video = '';
	// 	this.$nextTick(() => {
	// 		next();
	// 	});
	// }
};
</script>
<style lang="less">
.video {
	width: 100vw;
	height: 92vh;
	display: block;
}

.body {
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #000;
}

/* 控件按钮样式 */
.vjs-control-bar .vjs-icon-placeholder,
.vjs-control-bar .vjs-icon-placeholder:before,
.vjs-control-bar .vjs-icon-placeholder:after,
.vjs-control-bar .vjs-icon-placeholder.vjs-icon-volume-mute:before,
.vjs-control-bar .vjs-button .vjs-icon-placeholder,
.vjs-control-bar .vjs-button .vjs-icon-placeholder:before,
.vjs-control-bar .vjs-button .vjs-icon-placeholder:after {
	font-size: 38px !important; /* 设置控件按钮字体大小为28像素 */
}

.video-js .vjs-control-bar {
	height: 60px !important;
	display: flex;
	align-items: center;
	& > * {
		height: 100%;
		display: flex;
		align-items: center;
		margin: 0 6px;
		span {
			height: 100%;
			display: flex;
			align-items: center;
			font-size: 26px !important; /* 设置控件按钮字体大小为28像素 */
			&::before {
			}
		}
	}

	.vjs-time-control {
		margin: 0 !important;
	}
}

.video-js .vjs-progress-control {
}
</style>
